import { getAccountService } from '../apiCommon';

export async function pushToKafka(app, data) {
  const service = getAccountService(app, 'kafka_log/push');
  console.log('service', service);
  const result = await service.update(data.id);
  console.log('@pushToKafka result:', result);
  return result;
}
